import React from 'react';
import IdentityDetailsContainer from '../../containers/IdentityDetailsContainer';

const IdentityDetailsPage = () => {
  return <IdentityDetailsContainer />;
};

export default IdentityDetailsPage;
